export default "__VITE_ASSET__D3wYJ60M__"